import { httpClient } from '@shared/api'
import type {
    CancelEmployeeArgs,
    ConfirmEmployeeArgs,
    CreateEmployeeArgs,
    DeleteEmployeeArgs,
    EditEmployeeArgs
} from './types'

export const createEmployee = async (data: CreateEmployeeArgs): Promise<void> => {
    await httpClient.post<void>('/employees', data)
}

export const editEmployee = async ({ id, ...rest }: EditEmployeeArgs): Promise<void> => {
    await httpClient.patch<void>(`/employees/${id}`, rest)
}

export const deleteEmployee = async ({ id }: DeleteEmployeeArgs): Promise<void> => {
    await httpClient.delete<void>(`/employees/${id}`)
}

export const confirmEmployee = async (data: ConfirmEmployeeArgs): Promise<void> => {
    await httpClient.post<void>(`/employees/confirm`, data)
}

export const cancelEmployee = async (data: CancelEmployeeArgs): Promise<void> => {
    await httpClient.post<void>(`/employees/cancel-confirm`, data)
}
